import React, { useRef } from 'react';
import { motion, useMotionValue, useSpring, useTransform } from 'framer-motion';
import type { Variants } from 'framer-motion';
import { useMotionPreferences } from '../../hooks/useMotionPreferences';
type TiltCardProps = {
  children: React.ReactNode;
  className?: string;
  /** Reveal variants — inherited from a parent stagger container. */
  variants?: Variants;
  /** Maximum tilt in degrees on each axis. */
  maxTilt?: number;
  as?: 'div' | 'article';
};
const tiltSpring = {
  stiffness: 220,
  damping: 18,
  mass: 0.4
};
export function TiltCard({
  children,
  className = '',
  variants,
  maxTilt = 8,
  as = 'div'
}: TiltCardProps) {
  const {
    tiltEnabled
  } = useMotionPreferences();
  const ref = useRef<HTMLDivElement>(null);
  const pointerX = useMotionValue(0);
  const pointerY = useMotionValue(0);
  const rotateX = useSpring(useTransform(pointerY, [-0.5, 0.5], [maxTilt, -maxTilt]), tiltSpring);
  const rotateY = useSpring(useTransform(pointerX, [-0.5, 0.5], [-maxTilt, maxTilt]), tiltSpring);
  const handleMove = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!tiltEnabled || !ref.current) return;
    const bounds = ref.current.getBoundingClientRect();
    pointerX.set((event.clientX - bounds.left) / bounds.width - 0.5);
    pointerY.set((event.clientY - bounds.top) / bounds.height - 0.5);
  };
  const handleLeave = () => {
    pointerX.set(0);
    pointerY.set(0);
  };
  const MotionTag = as === 'article' ? motion.article : motion.div;
  return <motion.div variants={variants} className="[perspective:1200px]" data-id="element-130" data-mp="66q7o28mjkyi">
      <MotionTag ref={ref} onMouseMove={handleMove} onMouseLeave={handleLeave} style={tiltEnabled ? {
      rotateX,
      rotateY,
      transformStyle: 'preserve-3d',
      willChange: 'transform'
    } : undefined} whileHover={tiltEnabled ? {
      scale: 1.025
    } : {
      scale: 1.01
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 22
    }} className={className} data-id="element-131" data-mp="64vlylpj3otd">
        {children}
      </MotionTag>
    </motion.div>;
}